import { useState, useEffect, useRef } from 'react';
import DropDownSearch from '../../../../../components/DropDownSearch';
import { Button, Col, Form, ListGroup, Row } from 'react-bootstrap';
import HesSpinner from '../../../../../components/loadingOverlay/hesSpinner';
import { useOutletContext } from 'react-router';
import { useQuestionSearchContext } from '../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark as solidXmark } from '@fortawesome/pro-solid-svg-icons';
import { faMagnifyingGlass, faCircleXmark as lightXmark } from '@fortawesome/pro-light-svg-icons';
import { useGetCourseLevelsMutation, useGetTopicsByLevelMutation } from '../../../../../features/authentication/questionSearchApiSlice';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import TreeSelect from '../../../../../../src/components/TreeSelect/index';

const Questions = () => {
  const [searchType, setSearchType] = useState('basic');
  const [courseFilterOptions, setCourseFilterOptions] = useState([]);
  const questionSearchContext = useQuestionSearchContext();
  const outletContext = useOutletContext();
  const [keyword, setKeyword] = useState();
  const [clearHover, setClearHover] = useState(false);
  const searchBoxRef = useRef();
  const [getCourseLevels] = useGetCourseLevelsMutation();
  const [getTopicsByLevel] = useGetTopicsByLevelMutation();
  const [isLevelsLoading, setIsLevelsLoading] = useState(false);
  const [courseLevelIds, setCourseLevelIds] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(-1);
  const [topicNodes, setTopicNodes] = useState([]);
  const [selectedTopicNodes, setSelectedTopicNodes] = useState([]);
  const [topicNodesCount, setTopicNodeCount] = useState(0);
  const [isTreeLoading, setIsTreeLoading] = useState(false);
  const [foreignCourses, setForeignCourses] = useState([]);
  const foreignLanguageCourseId = 105;

  useEffect(() => {
    if (!outletContext.courseFilters.isSuccess) return;
    var courses = [...outletContext.courseFilters.data.courses];
    courses.pop();
    setCourseFilterOptions(courses);
  }, [outletContext.courseFilters]);

  const handleAdvancedCourseSelectionChange = (e, filterList, setFilterList) => {
    const { key } = e;
    const selected = (key !== '000') ? filterList.find((v) => v.id == key) : filterList;
    let tempValue = [];

    if (key === '000') {
      tempValue = filterList.map((item) => ({
        ...item,
        isChecked: !filterList.filter(item => item?.isChecked !== true).length < 1,
      }));

    } else {
      tempValue = filterList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }

    // Remove all courseIds from selected list
    var tempSelectedCourses = questionSearchContext.questionsTabAdvSelectedCourseIds.filter(s => !filterList.some(l => l.id === s));

    if (tempValue.filter(v => v.isChecked).length === filterList.length) {
      tempSelectedCourses = tempSelectedCourses.concat(filterList.slice(1, filterList.length).map(f => f.id));
    } else if (key != filterList[0].id) {
      tempSelectedCourses = tempSelectedCourses.concat(tempValue.filter(v => v.isChecked && v.id != filterList[0].id).map(v => v.id));
    }
    questionSearchContext.setQuestionsTabAdvSelectedCourseIds(tempSelectedCourses);
    setFilterList(tempValue);
  };

  const handleBasicGradeLevelSelection = (gradeFilter) => {
    var isSelected = !questionSearchContext.questionsTabBasicGradeIds.includes(gradeFilter.id);

    var selectedGradeIds = [];
    if (isSelected) {
      selectedGradeIds = [...questionSearchContext.questionsTabBasicGradeIds, gradeFilter.id];
    } else {
      selectedGradeIds = questionSearchContext.questionsTabBasicGradeIds.filter(g => g != gradeFilter.id);
    }
    questionSearchContext.setQuestionsTabBasicGradeIds(selectedGradeIds);
    setTopicNodes([]);
    setSelectedTopicNodes([]);
    setTopicNodeCount(0);
  };

  const handleForeignLanguageSelction = (parent) => {  
    const updatedCourses = foreignCourses.map(course =>
      course.parent == parent ? { ...course, isSelected: !course.isSelected } : course
    );
    setForeignCourses(updatedCourses);
  };

  const handleBasicTopLevelCourseSelection = (item) => {
    if (item.mainCourse.id == questionSearchContext.questionsTabBasicCourse?.mainCourse?.id) return;
    let allCourses = [];
    if (item.mainCourse.id == foreignLanguageCourseId) {
      allCourses = item.subCourses.map(item => item.id);
      let courses = [];
      item.subCourses.slice(1).map((item) => (
        courses.push({
          id: item.id,
          name: item.name,
          parent: item.name.includes('Spanish') ? 'Spanish' : 'French',
          isSelected: false
        })
      ));
      const sortedArray = courses.sort((a, b) => a.id - b.id);
      setForeignCourses(sortedArray);
    }
    else {
      allCourses = [item.mainCourse.id];
    }
    getCourseLevelsAsync(allCourses);
    setSelectedCourseId(item.mainCourse.id);
    questionSearchContext.setQuestionsTabBasicCourse(item);
    setCourseLevelIds([]);
    questionSearchContext.setQuestionsTabBasicGradeIds([]);
    setTopicNodes([]);
    setSelectedTopicNodes([]);
    setTopicNodeCount(0);
  };

  const getCourseLevelsAsync = async (courseIds) => {
    setIsLevelsLoading(true);
    const params = new URLSearchParams();
    courseIds.forEach(item => params.append('ids', item));
    var response = await getCourseLevels(params.toString()).unwrap();
    const levelIds = response.map(item => item.id);
    setCourseLevelIds(levelIds);
    setIsLevelsLoading(false);
  };

  const SearchQuestions = () => {
    var searchRequest = {
      pageNumber: 1,
      pageSize: 25
    };

    if (searchType === 'basic') {
      searchRequest.courseIds = selectedCourseId == foreignLanguageCourseId ? [...(foreignCourses.filter(item=>item.isSelected).map(item=>item.id)), foreignLanguageCourseId] : questionSearchContext.questionsTabBasicCourse.subCourses.map(c => c.id);
      searchRequest.levels = questionSearchContext.gradeFilterOptions.filter(g => questionSearchContext.questionsTabBasicGradeIds.includes(g.id)).map(g => g.gradeId).flat();
      searchRequest.topics = selectedTopicNodes.map(g => g).flat();
    } else {
      searchRequest.courseIds = questionSearchContext.questionsTabAdvSelectedCourseIds;
      searchRequest.keyword = keyword;
    }

    outletContext.intializeCastleSearch(searchRequest);
  };

  const handleClearSearch = () => {
    searchBoxRef.current.value = '';
    searchBoxRef.current.focus();
    setKeyword('');
  };

  const topicTreeHandler = async (rootName, nodeValue, isChildAvailable, childrens, index) => {
    let response = [];
    if (isChildAvailable)
      response = childrens;
    else {
      setIsTreeLoading(true);
      const levels = questionSearchContext.gradeFilterOptions.filter(g => questionSearchContext.questionsTabBasicGradeIds.includes(g.id)).map(g => g.gradeId).flat();
      const option = {
        courseId: selectedCourseId,
        levelIds: levels
      };
      response = await getTopicsByLevel(option).unwrap();
      setTopicNodes(response);
      setIsTreeLoading(false);
    }
    setTreeNodes(response, nodeValue, rootName, topicNodes, setTopicNodes, setTopicNodeCount, index);
  };

  const setTreeNodes = async (response, nodeValue, rootName, nodes, setNodes, setNodeCount, treeIndex) => {
    try {
      if (nodeValue == 'root') {
        setNodes(response);
        setNodeCount(response.length);
      } else {
        const newIds = response.map((newItem) => newItem.id);
        if (
          !nodes[treeIndex]
            .find((i) => i.name == rootName)
            .childrens.some((item2) => item2.id == newIds[0])
        ) {
          var selectedTree = nodes[treeIndex];
          const updatedTree = selectedTree.map((item) => {
            if (item.name === rootName) {
              const updatedChildrens = item.childrens.map((child) => {
                if (child.id == nodeValue) {
                  return { ...child, children: newIds };
                }
                return child;
              });
              return { ...item, childrens: [...updatedChildrens, ...response] };
            }
            return item;
          });
          let tempTree = [...nodes];
          tempTree[treeIndex] = updatedTree;
          setNodes(tempTree);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getGradeStatus = (item) => {
    const isEnabled = !(item.gradeId.some((item) => courseLevelIds.includes(item)));
    return isEnabled;
  };

  const getGroupedCourses = (courses) => {
    return courses.reduce((acc, course) => {
      if (!acc[course.parent]) {
        acc[course.parent] = [];
      }
      acc[course.parent].push(course);
      return acc;
    }, {});
  };

  return (
    <div className='d-flex flex-column castleQuestionsSearchBox'>

      {outletContext.courseFilters.isError && <div className='d-flex w-100 justify-content-center align-items-center'>
        <button style={{ color: '#F84646', fontSize: '1.15rem', border: 'none', background: 'none' }} onClick={() => outletContext.fetchCourseFilters()}>There was an error getting your courses. Click to try again</button>
      </div>}

      {outletContext.courseFilters.isLoading && <div className='d-flex flex-row w-100 justify-content-center align-items-center'>
        <HesSpinner width='2%' />
        <span style={{ fontSize: '2em' }} className='ms-2'>Getting your courses...</span>
      </div>}


      {outletContext.courseFilters.isSuccess && <div className='castleQuestionsSearchTypeList mb-3'>
        <span className={`px-3 py-2 ${searchType == 'basic' ? 'active' : ''}`} style={{ borderRadius: '7px 0 0 7px' }} onClick={() => setSearchType('basic')}>Basic Search</span>
        <span className={`px-3 py-2 ${searchType == 'advanced' ? 'active' : ''}`} style={{ borderRadius: '0 7px 7px 0' }} onClick={() => setSearchType('advanced')}>Advanced Search</span>
      </div>}


      {searchType === 'basic' ?
        // Basic Search
        <div className='d-flex flex-column'>
          {outletContext.courseFilters.isSuccess &&
            <div className='mb-3'>
              <div className='d-flex flex-column w-100 mb-3 mt-3'>
                <span className='fw-500'>Select Course</span>
                <div className='d-flex flex-row justify-content-start'>
                  {courseFilterOptions.map((item, index) => {
                    return (
                      <Button key={`courseFilter${index}`} style={{ width: '25%' }} variant='castleGray' className={`filterButton ${item.mainCourse.id === questionSearchContext.questionsTabBasicCourse?.mainCourse?.id ? 'active' : ''}`}
                        onClick={() => handleBasicTopLevelCourseSelection(item)}>{item.mainCourse.name}</Button>
                    );
                  })}
                </div>
              </div>
              {selectedCourseId >= 0 &&
                <>
                  {isLevelsLoading ?
                    (<SkeletonGrid
                      rowCount={1}
                      colCount={12}
                      className='p-3'
                    />) : (
                      <div className='d-flex flex-column w-100'>
                        <span className='fw-500'>Select Grade</span>
                        <div className='d-flex flex-row justify-content-between'>
                          {questionSearchContext.gradeFilterOptions.map((item, index) => {
                            return (
                              <Button key={`gradeFilter${index}`} variant='castleGray' className={`filterButton ${questionSearchContext.questionsTabBasicGradeIds.includes(item.id) ? 'active' : ''} ${getGradeStatus(item) ? 'text-grey cursor-not-allowed' : ''}`}
                                onClick={() => handleBasicGradeLevelSelection(item)} disabled={getGradeStatus(item)}>{item.name}</Button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                </>
              }
            </div>
          }
          {(selectedCourseId === foreignLanguageCourseId && questionSearchContext.questionsTabBasicGradeIds.length > 0) ? (
            <div>
              <span className="fw-500 mb-3">Select Topic</span>
              <Row className="mt-4">
                {Object.entries(getGroupedCourses(foreignCourses)).map(([parent, courseList]) => (
                  <Col className="col-2" key={parent}>
                    <Button
                      variant="castleGray"
                      className={`filterButton ${courseList.filter(item => item.isSelected).length > 0 ? 'active' : ''}`}
                      onClick={() => handleForeignLanguageSelction(parent)}
                    >
                      {parent}
                    </Button>
                  </Col>
                ))}
              </Row>
            </div>            
          ) : (
            <div className="mt-4">
              {isTreeLoading ? (
                <SkeletonGrid rowCount={1} colCount={1} className="p-2" />
              ) : (
                <>
                  {topicNodes.length > 0 &&
                <>
                  <span className='fw-500 mb-3'>Select Topic</span>
                  <Row>
                    {topicNodes.map((node,index)=>  (
                      <Col className='col-4 mt-2' key={index}>
                        <TreeSelect
                          key={index}
                          nodes={node}
                          treeNodeHandler={topicTreeHandler}
                          parentNodesCount={topicNodesCount}
                          selectedChildIds={selectedTopicNodes}
                          setSelectedChildIds={setSelectedTopicNodes}
                          treeIndex={index}
                        />
                      </Col>
                    ))} 
                  </Row>
                </>}
                </>
              )
              }
            </div>
          )
          }
          {!outletContext.courseFilters.isError && !outletContext.courseFilters.isLoading && questionSearchContext.questionsTabBasicGradeIds != null && questionSearchContext.questionsTabBasicCourse != null &&
            <div className='d-flex flex-row justify-content-center align-items-center gap-4 mt-4'>
              {selectedCourseId != foreignLanguageCourseId ?
                (
                  <>
                    {topicNodes.length > 0 ?
                      (
                        <Button variant={'castleRed'}
                          style={{ width: '20%' }}
                          onClick={() => SearchQuestions()} disabled={questionSearchContext.isSearching || questionSearchContext.questionsTabBasicGradeIds?.length == 0 || questionSearchContext.questionsTabBasicCourse == null || selectedTopicNodes.length == 0}>
                          Show me Questions
                        </Button>) : (
                        <Button variant={'castleWhite'}
                          style={{ width: '20%' }}
                          onClick={() => topicTreeHandler('', 'root')} disabled={questionSearchContext.isSearching || questionSearchContext.questionsTabBasicGradeIds?.length == 0 || questionSearchContext.questionsTabBasicCourse == null}>
                          Search
                        </Button>

                      )}
                  </>
                ) : (
                  <Button variant={'castleRed'}
                    style={{ width: '20%' }}
                    onClick={() => SearchQuestions()} disabled={questionSearchContext.isSearching || questionSearchContext.questionsTabBasicGradeIds?.length == 0 || questionSearchContext.questionsTabBasicCourse == null || foreignCourses.filter(item=> item.isSelected).length == 0}>
                    Show me Questions
                  </Button>
                )}
            </div>
          }

        </div>

        // Advanced Search
        :

        <div className='d-flex flex-column'>
          <span className='mb-3 fw-500'>Choose Courses</span>
          <div className='d-flex flex-row gap-2 mb-2'>
            {questionSearchContext.questionsTabAdvMathCourses.length > 0 && <div className='d-flex flex-column w-25'>
              <span>Math</span>
              <DropDownSearch
                value={questionSearchContext.questionsTabAdvMathCourses.filter(m => m.id != 101)}
                setValue={questionSearchContext.setQuestionsTabAdvMathCourses}
                dropdownId='mathCourseFilter'
                placeholder='Select Course'
                handleChange={(e) => handleAdvancedCourseSelectionChange(e, questionSearchContext.questionsTabAdvMathCourses, questionSearchContext.setQuestionsTabAdvMathCourses)}
                selectedId={questionSearchContext.questionsTabAdvMathCourses.filter(m => m.isChecked && m.id != 101).map(m => m.id)}
                description={true}
                selectAllText='All Math Courses'
              />
            </div>}
            {questionSearchContext.questionsTabAdvSocialStudiesCourses.length > 0 && <div className='d-flex flex-column w-25'>
              <span>Social Studies</span>
              <DropDownSearch
                value={questionSearchContext.questionsTabAdvSocialStudiesCourses.filter(m => m.id != 103)}
                setValue={questionSearchContext.setQuestionsTabAdvSocialStudiesCourses}
                dropdownId='socialStudiesCourseFilter'
                placeholder='Select Course'
                handleChange={(e) => handleAdvancedCourseSelectionChange(e, questionSearchContext.questionsTabAdvSocialStudiesCourses, questionSearchContext.setQuestionsTabAdvSocialStudiesCourses)}
                selectedId={questionSearchContext.questionsTabAdvSocialStudiesCourses.filter(m => m.isChecked && m.id != 103).map(m => m.id)}
                description={true}
                selectAllText='All Social Studies Courses'
              />
            </div>}
            {questionSearchContext.questionsTabAdvScienceCourses.length > 0 && <div className='d-flex flex-column w-25'>
              <span>Science</span>
              <DropDownSearch
                value={questionSearchContext.questionsTabAdvScienceCourses.filter(m => m.id != 102)}
                setValue={questionSearchContext.setQuestionsTabAdvScienceCourses}
                dropdownId='scienceCourseFilter'
                placeholder='Select Course'
                handleChange={(e) => handleAdvancedCourseSelectionChange(e, questionSearchContext.questionsTabAdvScienceCourses, questionSearchContext.setQuestionsTabAdvScienceCourses)}
                selectedId={questionSearchContext.questionsTabAdvScienceCourses.filter(m => m.isChecked && m.id != 102).map(m => m.id)}
                description={true}
                selectAllText='All Science Courses'
              />
            </div>}
            {questionSearchContext.questionsTabAdvEnglishCourses.length > 0 && <div className='d-flex flex-column w-25'>
              <span>ELA</span>
              <DropDownSearch
                value={questionSearchContext.questionsTabAdvEnglishCourses.filter(m => m.id != 104)}
                setValue={questionSearchContext.setQuestionsTabAdvEnglishCourses}
                dropdownId='englishFilterList'
                placeholder='Select Course'
                handleChange={(e) => handleAdvancedCourseSelectionChange(e, questionSearchContext.questionsTabAdvEnglishCourses, questionSearchContext.setQuestionsTabAdvEnglishCourses)}
                selectedId={questionSearchContext.questionsTabAdvEnglishCourses.filter(m => m.isChecked && m.id != 104).map(m => m.id)}
                description={true}
                selectAllText='All ELA Courses'
              />
            </div>}
            {questionSearchContext.questionsTabAdvForeignLangCourses.length > 0 && <div className='d-flex flex-column w-25'>
              <span>Foreign Language</span>
              <DropDownSearch
                value={questionSearchContext.questionsTabAdvForeignLangCourses.filter(m => m.id != foreignLanguageCourseId)}
                setValue={questionSearchContext.setQuestionsTabAdvForeignLangCourses}
                dropdownId='foreignLangFilterList'
                placeholder='Select Course'
                handleChange={(e) => handleAdvancedCourseSelectionChange(e, questionSearchContext.questionsTabAdvForeignLangCourses, questionSearchContext.setQuestionsTabAdvForeignLangCourses)}
                selectedId={questionSearchContext.questionsTabAdvForeignLangCourses.filter(m => m.isChecked && m.id != foreignLanguageCourseId).map(m => m.id)}
                description={true}
                selectAllText='All Foreign Language Courses'
              />
            </div>}
            {questionSearchContext.questionsTabAdvOtherCourses.length > 0 && <div className='d-flex flex-column w-25'>
              <span>Other</span>
              <DropDownSearch
                value={questionSearchContext.questionsTabAdvOtherCourses.filter(m => m.id != 0)}
                setValue={questionSearchContext.setQuestionsTabAdvOtherCourses}
                dropdownId='otherCourseFilter'
                placeholder='Select Course'
                handleChange={(e) => handleAdvancedCourseSelectionChange(e, questionSearchContext.questionsTabAdvOtherCourses, questionSearchContext.setQuestionsTabAdvOtherCourses)}
                selectedId={questionSearchContext.questionsTabAdvOtherCourses.filter(m => m.isChecked && m.id != 0).map(m => m.id)}
                description={true}
                selectAllText='All Other Courses'
              />
            </div>}
          </div>

          <div className='d-flex flex-row gap-2 align-items-center d-relative'>
            <ListGroup.Item className='mx-1 w-100'>
              <Form.Group id="standardSearchGroup">
                <div>
                  <Form.Control type='text' style={{ paddingLeft: '35px', paddingRight: '35px' }} placeholder='Keyword' ref={searchBoxRef} defaultValue={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onKeyUp={(e) => { if (questionSearchContext.questionsTabAdvSelectedCourseIds.length > 0 && e.key == 'Enter') SearchQuestions(); }} />
                  <FontAwesomeIcon className='searchIcon' icon={faMagnifyingGlass} />
                  <FontAwesomeIcon className={`clearSearchIcon ${keyword?.length > 0 ? '' : 'd-none'}`}
                    icon={clearHover ? solidXmark : lightXmark}
                    onMouseEnter={() => setClearHover(true)}
                    onMouseLeave={() => setClearHover(false)}
                    onClick={() => handleClearSearch()}
                  />
                </div>
              </Form.Group>
            </ListGroup.Item>
            <Button variant='castleWhite btn-width' disabled={questionSearchContext.isSearching || questionSearchContext.questionsTabAdvSelectedCourseIds.length <= 0} onClick={() => SearchQuestions()}>Search</Button>
          </div>
        </div>
      }
    </div>
  );
};

export default Questions;